/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Collection maps users to guilds.
 * @export
 * @interface GuildMembership
 */
export interface GuildMembership {
    /**
     * 
     * @type {string}
     * @memberof GuildMembership
     */
    guild: string;
    /**
     * 
     * @type {string}
     * @memberof GuildMembership
     */
    user: string;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    joinedAt: number;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    leftAt?: number;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    pointsEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    monthlyPointsEarned?: number;
    /**
     * 
     * @type {string}
     * @memberof GuildMembership
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof GuildMembership
     */
    updatedAt: number;
}

/**
 * Check if a given object implements the GuildMembership interface.
 */
export function instanceOfGuildMembership(value: object): value is GuildMembership {
    if (!('guild' in value) || value['guild'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('joinedAt' in value) || value['joinedAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GuildMembershipFromJSON(json: any): GuildMembership {
    return GuildMembershipFromJSONTyped(json, false);
}

export function GuildMembershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): GuildMembership {
    if (json == null) {
        return json;
    }
    return {
        
        'guild': json['guild'],
        'user': json['user'],
        'joinedAt': json['joinedAt'],
        'leftAt': json['leftAt'] == null ? undefined : json['leftAt'],
        'pointsEarned': json['pointsEarned'] == null ? undefined : json['pointsEarned'],
        'monthlyPointsEarned': json['monthlyPointsEarned'] == null ? undefined : json['monthlyPointsEarned'],
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function GuildMembershipToJSON(json: any): GuildMembership {
    return GuildMembershipToJSONTyped(json, false);
}

export function GuildMembershipToJSONTyped(value?: GuildMembership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guild': value['guild'],
        'user': value['user'],
        'joinedAt': value['joinedAt'],
        'leftAt': value['leftAt'],
        'pointsEarned': value['pointsEarned'],
        'monthlyPointsEarned': value['monthlyPointsEarned'],
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

